import Vuex from 'vuex';
import Vue from 'vue';

import AppModule from './app';
import ConfiguratorModule from './configurator';
import NavigationModule from './navigation';
import CheckoutModule from './checkout';
import OrderModule from './order';

// Load
Vue.use(Vuex);

// create store
const store = new Vuex.Store({
  modules: {
    app: AppModule,
    configurator: ConfiguratorModule,
    navigation: NavigationModule,
    checkout: CheckoutModule,
    order: OrderModule
  }
});

export default store;
